import React from 'react';
import {
  MDBCol,
  MDBRow,
  MDBInput,
  MDBModal,
  MDBNavLink,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBDataTable,
  MDBListGroup, MDBListGroupItem,
  MDBContainer, MDBInputGroup,
  MDBBtn
} from 'mdbreact';
import './statementTemplates-view.css';
import '../../styles/page-common.css';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import Breadcrumb from '../../components/breadcrumb';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';

class HomeView extends React.Component {

  state = {
    modal: false,
    pdfModal: false,
    newStatement: {},
    newLineItem: {},
    rankType: 'all'
  }

  handleChange = (value, prop) => {
    var t = this.state.newStatement;
    t[prop] = value;
    this.setState({
      newStatement: t
    });
  }

  handleLineChange = (value, prop) => {
    var t = this.state.newLineItem;
    t[prop] = value;
    this.setState({
      newLineItem: t
    });
  }

  togglePDF = () => {
    this.setState({
      pdfModal: !this.state.pdfModal,
    });
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      newStatement: {},
    });
  }

  addLineItem = () => {
    this.setState({
      newStatement: {
        ...this.state.newStatement,
        descriptions: this.state.newStatement.descriptions ? [...this.state.newStatement.descriptions, { ...this.state.newLineItem }] : [{ ...this.state.newLineItem }]
      }
    });
  }

  deleteLineItem = (desc) => {
    this.setState({
      newStatement: {
        ...this.state.newStatement,
        descriptions: this.state.newStatement.descriptions.filter(item => item.description != desc)
      }
    });
  }

  edit = (statement) => {
    this.setState({
      modal: !this.state.modal,
      newStatement: statement
    });
  }

  componentDidMount() {
    this.props.getStatementTemplates();
  }

  createStatement = () => {
    this.props.createStatement(this.state.newStatement);
    this.setState({
      modal: !this.state.modal,
      newStatement: ''
    });
  }

  scrollToTop = () => window.scrollTo(0, 0);

  getDataFromURL = (url) => new Promise((resolve, reject) => {
    setTimeout(() => {
      fetch(url)
        .then(response => response.blob())
        .then(data => {
          resolve(data)
        });
    });
  }, 2000);

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    var Statements = [];
    console.log(this.props);

    if (this.props.statementTemplates && this.props.statementTemplates.length > 0) {
      Statements = this.props.statementTemplates.map(p => {
        return {
          name: p.statementTemplateName,
          view: <Link to={"/statementTemplate/" + p._id}><MDBBtn color="yellow accent-4" rounded outline size="sm">view</MDBBtn></Link>,
        }
      });
    }

    const data = {
      columns: [
        {
          label: 'Name',
          field: 'name',
          sort: 'asc'
        },
        {
          label: '',
          field: 'view',
          sort: 'asc'
        }
      ],
      rows: Statements
    };

    return (
      <div className="content-wrapper">
        <SpinnerView showSpinner={this.props.loading} />

        {/* Page Header */}
        <div className="page-header">
          <h1 className="page-title">
            <i className="fas fa-file-invoice"></i>
            Statement Templates
          </h1>
        </div>

        <div style={{ padding: '0 20px 20px 20px' }}>
        <MDBDataTable
          disableRetreatAfterSorting={true}
          striped
          bordered
          small
          data={data}
        />

        <Fab onClick={this.toggle} className="fab primary-color" aria-label="add" style={{
          position: 'fixed'
        }}>
          <AddIcon />
        </Fab>
        </div>
      </div>
    );
  }
}
/*
    descriptions:[{
        name:"name",
        "price":100
    }],
    */
export default HomeView;
